import { CaseAutomaticNotificationTriggerResponse } from '@/modules/configurationModule/detail/automation/notifications/automation-notifications-case/services/configuration-case-automatic-notification-trigger/configuration-case-automatic-notification-trigger.dto'
import { CommonPetitionerResponse, EnumResponse } from '@/api/services/common.dto'
import { CommonDepartmentResponse } from '@/api/services/common/department/common-department.dto'
import { ConfigurationDepartmentResponse } from '@/modules/configurationModule/detail/automation/notifications/automation-notifications-case/services/configuration-department/configuration-department.dto'
import { CommonMorphologicCodeResponse } from '@/api/services/common/morphologic-code/common-morphologic-code.dto'
import { Nullable } from '@/shared/types/app.types'

export enum ConditionTypeEnum {
    COMPREHENSIVE_DIAGNOSIS_MORPHOLOGIC_CODES = 'COMPREHENSIVE_DIAGNOSIS_MORPHOLOGIC_CODES',
    DEPARTMENTS = 'DEPARTMENTS',
    PETITIONERS = 'PETITIONERS',
    SAMPLE_MORPHOLOGIC_CODES = 'SAMPLE_MORPHOLOGIC_CODES'
}
export interface ConditionType extends EnumResponse {
    code: ConditionTypeEnum
}

export type ConditionItem =
    CommonPetitionerResponse |
    (CommonDepartmentResponse | ConfigurationDepartmentResponse) |
    CommonMorphologicCodeResponse
export interface Condition {
    conditionType: ConditionType
    conditionItems: ConditionItem[]
}

export interface CaseAutomaticNotificationTriggerModalState {
    caseAutomaticNotificationTrigger: Partial<CaseAutomaticNotificationTriggerResponse>

    conditionType: Nullable<ConditionType>
    conditions: Condition[]
    originalConditions: readonly Condition[]

    petitioners: CommonPetitionerResponse[]
    departments: (CommonDepartmentResponse | ConfigurationDepartmentResponse)[]
    sampleMorphologicCodes: CommonMorphologicCodeResponse[]
    comprehensiveDiagnosisMorphologicCodes: CommonMorphologicCodeResponse[]
}
export const initialCaseAutomaticNotificationTriggerModalState =
    (): CaseAutomaticNotificationTriggerModalState => ({
        caseAutomaticNotificationTrigger: {},

        conditionType: null,
        conditions: [],
        originalConditions: [],

        petitioners: [],
        departments: [],
        sampleMorphologicCodes: [],
        comprehensiveDiagnosisMorphologicCodes: []
    })
